import { render, staticRenderFns } from "./System.vue?vue&type=template&id=1759be90&scoped=true&"
import script from "./System.vue?vue&type=script&lang=ts&"
export * from "./System.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1759be90",
  null
  
)

export default component.exports